// @ts-nocheck
import React from "react";
import {
  FaCreditCard,
  FaLocationArrow,
  FaRegBell,
  FaRegQuestionCircle,
} from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import useFetch from "../../../ApiClient/GetApi";
import Header from "../layout/Header";
import Moment from "react-moment";
import CopyButton from "./CopyButton";
export default function Dashboard() {
  const { data } = useFetch("users/home/user_dashboard");
  const navigate = useNavigate();
  const payment_and_invoices = () => {
    navigate("/payment_and_invoices");
  };
  const getting_started = () => {
    navigate("/getting_started");
  };
  return (
    <>
      <section className="font-soehne">
        <Header />
        <section className="xl:w-4/5 w-11/12 mx-auto my-12 grid lg:grid-cols-12 md:grid-cols-2 xl:gap-8 gap-6">
          <div className="lg:col-span-8 md:col-span-2 order-1 grid grid-cols-2 bg-themeBlue py-8 px-10 rounded-lg">
            <div className="flex flex-col justify-center items-start gap-y-8">
              <div className="w-12 h-12 bg-white rounded-fullest flex justify-center items-center">
                <img
                  src="images/dashboard/box.webp"
                  alt="box"
                  className="w-6"
                />
              </div>
              <div className="space-y-3">
                <h1 className="font-medium text-3xl text-white">My Orders</h1>
                <p className="font-normal text-base text-white">
                  You have currently {data?.data?.orders ?? "0"} orders
                </p>
              </div>
              <div>
                <Link
                  to={`/my_orders`}
                  className="bg-white text-themeBlue border border-white font-medium text-xl rounded-md 
                      py-3 px-10 hover:bg-themeBlue hover:text-white"
                >
                  View Details
                </Link>
              </div>
            </div>
            <div className="flex justify-end items-center">
              <img
                src="images/dashboard/car_loader.webp"
                alt="car"
                className="w-56"
              />
            </div>
          </div>
          <div className="lg:col-span-4 md:col-span-2 lg:order-2 order-5 lg:row-span-3 bg-themeBlue6 py-8 px-8 rounded-lg">
            <div className="flex flex-col justify-center items-start">
              <div
                className="w-12 h-12 bg-white text-themeRed rounded-fullest flex justify-center 
                items-center"
              >
                <FaRegBell size={24} />
              </div>
              <h1 className="font-medium text-3xl text-black mt-4">
                Notifications
              </h1>
              {data?.data?.notifications?.map((noti) => (
                <div
                  className="flex items-start justify-between border-b gap-x-3 border-black 
                  border-opacity-40 py-4 "
                >
                  <p className="font-normal text-base">{noti.body}</p>
                  <p className="font-normal text-sm text-black text-opacity-60 w-fit whitespace-nowrap">
                    <Moment format="D MMM YYYY">{noti.time}</Moment>
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-4 lg:order-3 order-2 bg-themeBlue3 py-8 px-10 rounded-lg">
            <div className="flex flex-col justify-center items-start gap-y-8">
              <div
                className="w-12 h-12 bg-white text-themeBlue3 rounded-fullest flex justify-center 
                items-center"
              >
                <FaRegQuestionCircle size={24} />
              </div>
              <div className="space-y-3">
                <h1 className="font-medium text-3xl text-white">
                  Getting Started
                </h1>
                <p className="font-normal text-base text-white">
                  A quick view of “ How pacifrica works”?
                </p>
              </div>
              <div>
                <button
                  onClick={getting_started}
                  className="bg-white text-themeBlue3 border border-white font-medium text-xl rounded-md 
                    py-2 px-10 hover:bg-themeBlue3 hover:text-white"
                >
                  Learn More
                </button>
              </div>
            </div>
          </div>
          <div className="lg:col-span-4 lg:order-4 order-3 bg-themeBlue4 py-8 px-10 rounded-lg">
            <div className="flex flex-col justify-center items-start gap-y-8">
              <div
                className="w-12 h-12 bg-white text-themeBlue4 rounded-fullest flex justify-center 
                items-center"
              >
                <FaCreditCard size={24} />
              </div>
              <div className="space-y-3">
                <h1 className="font-medium text-3xl text-white">
                  Payment and Invoices
                </h1>
                <p className="font-normal text-base text-white">
                  Learn how payments and invoicing are processed.
                </p>
              </div>
              <div>
                <button
                  onClick={payment_and_invoices}
                  className="bg-white text-themeBlue4 border border-white font-medium text-xl rounded-md 
                    py-2 px-10 hover:bg-themeBlue4 hover:text-white"
                >
                  Learn More
                </button>
              </div>
            </div>
          </div>
          <div className="lg:col-span-8 lg:order-5 order-4 md:col-span-2 bg-themeBlue5 py-8 px-10 rounded-lg">
            <div className="flex flex-col justify-center items-start gap-y-8">
              <div
                className="w-12 h-12 bg-white text-themeBlue5 rounded-fullest flex justify-center 
                    items-center"
              >
                <img src="images/location_logo.png" alt="location logo" />
              </div>
              <div className="space-y-3">
                <h1 className="font-medium text-3xl text-black">Address</h1>
                <div className="flex justify-between items-center w-full">
                  <p className="font-normal text-xl text-black pr-6">
                    {data?.data?.address?.zipCode} ,{" "}
                    {data?.data?.address?.address} , {data?.data?.address?.city}{" "}
                    , {data?.data?.address?.state} ,{" "}
                    {data?.data?.address?.country}
                  </p>
                  <div className="">
                    <CopyButton
                      className=""
                      text={`${data?.data?.address?.zipCode} ${data?.data?.address?.address} ${data?.data?.address?.city} ${data?.data?.address?.state} 
                  ${data?.data?.address?.country}`}
                    />
                  </div>
                </div>
                <div className="flex justify-between items-center w-full">
                  <p className="font-normal text-xl text-black pr-6">
                    {data?.data?.chines?.zipCode} ,{" "}
                    {data?.data?.chines?.address} , {data?.data?.chines?.city} ,{" "}
                    {data?.data?.chines?.state} , {data?.data?.chines?.country}
                  </p>
                  <div className="">
                    <CopyButton
                      className=""
                      text={`${data?.data?.chines?.zipCode} ${data?.data?.chines?.address} ${data?.data?.chines?.city} ${data?.data?.chines?.state} ${data?.data?.chines?.country}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
